import { render, staticRenderFns } from "./XXJGS_Page.vue?vue&type=template&id=3b805221&scoped=true&"
import script from "./XXJGS_Page.vue?vue&type=script&lang=js&"
export * from "./XXJGS_Page.vue?vue&type=script&lang=js&"
import style0 from "./XXJGS_Page.vue?vue&type=style&index=0&id=3b805221&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b805221",
  null
  
)

export default component.exports